<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      @reload="() => $refs.header.query()"
      @openDetailDialog="openDetailDialog"
      @batchDel="submitDel"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        @query="getData"
        @openDetailDialog="openDetailDialog"
        @batchDel="batchDel"
      />
    </page-main>
    <edit-doc
      :disabled="detailDialogParams.disabled"
      :visible="detailDialogParams.visible"
      :title="detailDialogParams.title"
      :techDocCode="detailDialogParams.code"
      :orderCode="orderCode"
      :techCode="techCode"
      @close="() => (detailDialogParams.visible = false)"
      @reload="() => $refs.header.query()"
      ref="editDocDialog"
    />
  </div>
</template>
<script>
import PageMain from './main.vue'
import PageHeader from './header.vue'
import EditDoc from '../edit-form/dialog.vue'
export default {
  props: {
    orderCode: { type: String, default: '' },
    techCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  components: {
    PageMain,
    PageHeader,
    EditDoc,
  },
  data() {
    return {
      tableData: [],
      loading: false,
      detailDialogParams: {
        visible: false,
        title: '',
        disabled: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .techDocListApi({ techCode: this.techCode, ...form })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    openDetailDialog({ type, code = '' }) {
      const types = {
        add:
          this.$l('dialog_title_process_order_doc_add_info') ||
          '添加工艺单文档信息',
        edit:
          this.$l('dialog_title_process_order_doc_edit_info') ||
          '编辑工艺单文档信息',
        detail:
          this.$l('dialog_title_process_order_doc_detail_info') ||
          '工艺单文档详情',
      }
      this.detailDialogParams = {
        visible: true,
        title: types[type],
        code,
        disabled: type === 'detail',
      }
    },
    // 批量删除
    batchDel() {
      const listCode = this.$refs.main.getCheckboxRecords()
      if (listCode) this.submitDel(listCode)
    },
    submitDel(listCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.$api.techDocDelApi({ listCode }).then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$refs.header.query()
          })
        })
        .catch(() => {})
    },
  },
}
</script>
